/**
 * Checks if the current device is iOS (iPad, iPhone, or iPod)
 */
export const isIOS = (): boolean => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
}

/**
 * Checks if the current environment is iOS WebView (WKWebView)
 * iOS WebView doesn't include 'Safari/' in user agent string
 */
export const isIOSWebView = (): boolean => {
  return isIOS() && !navigator.userAgent.includes('Safari/')
}

/**
 * Checks if the current environment supports Service Workers and is not iOS WebView
 */
export const canUseServiceWorkers = (): boolean => {
  return 'serviceWorker' in navigator && !isIOSWebView()
}

/**
 * Checks if the current environment supports Web Notifications
 */
export const hasNotificationSupport = (): boolean => {
  return 'Notification' in window && typeof Notification.requestPermission === 'function'
}

/**
 * Checks if the current environment can use push notifications
 * (has both Service Worker and Notification support, and is not iOS WebView)
 */
export const canUsePushNotifications = (): boolean => {
  return canUseServiceWorkers() && hasNotificationSupport()
}
